// node-modules
import React from 'react';
// hooks
import useCurrentTheme from 'utils/hooks/useCurrentTheme';

interface ProgressIconProps {
  filledCount: number;
}

export const ProgressIcon = ({ filledCount }: ProgressIconProps) => {
  const currentTheme = useCurrentTheme();
  const isDarkTheme = currentTheme === 'dark';

  const colors = {
    stroke: isDarkTheme ? '#1F222C' : '#ffffff',
    bar: isDarkTheme ? '#6CBA90' : '#148564',
    cloud: isDarkTheme ? '#ffffff' : '#262626',
  };

  const filledPaths = [
    filledCount >= 1,
    filledCount >= 2,
    filledCount >= 3,
    filledCount >= 4,
  ];

  return (
    <svg
      width="112"
      height="112"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={filledPaths[1] ? '1' : '0.38'}>
        <mask id="path-2-inside-1_2353_46734" fill="white">
          <path d="M112 56C112 63.354 110.552 70.636 107.737 77.4303C104.923 84.2245 100.798 90.3979 95.598 95.598C90.3979 100.798 84.2245 104.923 77.4303 107.737C70.636 110.552 63.354 112 56 112V100.8C61.8832 100.8 67.7088 99.6412 73.1442 97.3898C78.5796 95.1384 83.5183 91.8384 87.6784 87.6784C91.8384 83.5183 95.1384 78.5796 97.3898 73.1442C99.6412 67.7088 100.8 61.8832 100.8 56H112Z" />
        </mask>
        <path
          d="M112 56C112 63.354 110.552 70.636 107.737 77.4303C104.923 84.2245 100.798 90.3979 95.598 95.598C90.3979 100.798 84.2245 104.923 77.4303 107.737C70.636 110.552 63.354 112 56 112V100.8C61.8832 100.8 67.7088 99.6412 73.1442 97.3898C78.5796 95.1384 83.5183 91.8384 87.6784 87.6784C91.8384 83.5183 95.1384 78.5796 97.3898 73.1442C99.6412 67.7088 100.8 61.8832 100.8 56H112Z"
          fill={colors.bar}
          stroke={colors.stroke}
          strokeWidth="4"
          mask="url(#path-2-inside-1_2353_46734)"
        />
      </g>
      <g opacity={filledPaths[0] ? '1' : '0.38'}>
        <mask id="path-3-inside-2_2353_46734" fill="white">
          <path d="M56 -2.44784e-06C63.354 -2.76929e-06 70.636 1.44848 77.4303 4.26275C84.2245 7.07701 90.3979 11.2019 95.598 16.402C100.798 21.6021 104.923 27.7755 107.737 34.5697C110.552 41.364 112 48.646 112 56L100.8 56C100.8 50.1168 99.6412 44.2912 97.3898 38.8558C95.1384 33.4204 91.8384 28.4817 87.6784 24.3216C83.5183 20.1615 78.5796 16.8616 73.1442 14.6102C67.7088 12.3588 61.8832 11.2 56 11.2L56 -2.44784e-06Z" />
        </mask>
        <path
          d="M56 -2.44784e-06C63.354 -2.76929e-06 70.636 1.44848 77.4303 4.26275C84.2245 7.07701 90.3979 11.2019 95.598 16.402C100.798 21.6021 104.923 27.7755 107.737 34.5697C110.552 41.364 112 48.646 112 56L100.8 56C100.8 50.1168 99.6412 44.2912 97.3898 38.8558C95.1384 33.4204 91.8384 28.4817 87.6784 24.3216C83.5183 20.1615 78.5796 16.8616 73.1442 14.6102C67.7088 12.3588 61.8832 11.2 56 11.2L56 -2.44784e-06Z"
          fill={colors.bar}
          stroke={colors.stroke}
          strokeWidth="4"
          mask="url(#path-3-inside-2_2353_46734)"
        />
      </g>
      <g opacity={filledPaths[3] ? '1' : '0.38'}>
        <mask id="path-4-inside-3_2353_46734" fill="white">
          <path d="M4.89568e-06 56C5.53858e-06 48.646 1.44849 41.364 4.26276 34.5697C7.07702 27.7755 11.202 21.6021 16.402 16.402C21.6021 11.2019 27.7755 7.077 34.5697 4.26274C41.364 1.44847 48.646 -5.53858e-06 56 -4.89568e-06L56 11.2C50.1168 11.2 44.2912 12.3588 38.8558 14.6102C33.4204 16.8616 28.4817 20.1615 24.3216 24.3216C20.1616 28.4817 16.8616 33.4204 14.6102 38.8558C12.3588 44.2912 11.2 50.1168 11.2 56L4.89568e-06 56Z" />
        </mask>
        <path
          d="M4.89568e-06 56C5.53858e-06 48.646 1.44849 41.364 4.26276 34.5697C7.07702 27.7755 11.202 21.6021 16.402 16.402C21.6021 11.2019 27.7755 7.077 34.5697 4.26274C41.364 1.44847 48.646 -5.53858e-06 56 -4.89568e-06L56 11.2C50.1168 11.2 44.2912 12.3588 38.8558 14.6102C33.4204 16.8616 28.4817 20.1615 24.3216 24.3216C20.1616 28.4817 16.8616 33.4204 14.6102 38.8558C12.3588 44.2912 11.2 50.1168 11.2 56L4.89568e-06 56Z"
          fill={colors.bar}
          stroke={colors.stroke}
          strokeWidth="4"
          mask="url(#path-4-inside-3_2353_46734)"
        />
      </g>
      <g opacity={filledPaths[2] ? '1' : '0.38'}>
        <mask id="path-5-inside-4_2353_46734" fill="white">
          <path d="M56 112C48.646 112 41.364 110.552 34.5697 107.737C27.7755 104.923 21.6021 100.798 16.402 95.598C11.2019 90.3979 7.07701 84.2245 4.26275 77.4303C1.44848 70.636 7.55489e-07 63.354 6.67793e-07 56L11.2 56C11.2 61.8832 12.3588 67.7088 14.6102 73.1442C16.8616 78.5796 20.1616 83.5183 24.3216 87.6784C28.4817 91.8384 33.4204 95.1384 38.8558 97.3898C44.2912 99.6412 50.1168 100.8 56 100.8L56 112Z" />
        </mask>
        <path
          d="M56 112C48.646 112 41.364 110.552 34.5697 107.737C27.7755 104.923 21.6021 100.798 16.402 95.598C11.2019 90.3979 7.07701 84.2245 4.26275 77.4303C1.44848 70.636 7.55489e-07 63.354 6.67793e-07 56L11.2 56C11.2 61.8832 12.3588 67.7088 14.6102 73.1442C16.8616 78.5796 20.1616 83.5183 24.3216 87.6784C28.4817 91.8384 33.4204 95.1384 38.8558 97.3898C44.2912 99.6412 50.1168 100.8 56 100.8L56 112Z"
          fill={colors.bar}
          stroke={colors.stroke}
          strokeWidth="4"
          mask="url(#path-5-inside-4_2353_46734)"
        />
      </g>
      <path
        d="M62 68.4803H69.125C74.2812 68.4803 78.5 65.7419 78.5 60.6428C78.5 55.5438 73.5312 53.005 69.5 52.8053C68.6666 44.831 62.8438 39.9803 56 39.9803C49.5312 39.9803 45.365 44.2732 44 48.5303C38.375 49.0647 33.5 52.6441 33.5 58.5053C33.5 64.3666 38.5625 68.4803 44.75 68.4803H50"
        stroke={colors.cloud}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62 57.9803L56 51.9803L50 57.9803M56 76.0197V53.4803"
        stroke={colors.cloud}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
